<template>
  <li @touchstart="onTouchStart" class="group inline-block mr-[8px] relative">
    <router-link
      v-if="to"
      :to="to"
      custom
      v-slot="{ href, route, navigate, isActive, isExactActive }"
    >
      <a
        :href="href"
        :class="[
          { 'has-nested-list': items?.length },
          isActive
            ? 'bg-blush-500 hover:bg-blush-600 text-orange-500 px-[15px]'
            : 'bg-orange-500 hover:bg-orange-600 text-white px-[16px]',
        ]"
        class="button block py-[12px] z-10"
        @click="navigate"
        >{{ title }}</a
      >
    </router-link>
    <template v-else>{{ title }}</template>

    <ul
      class="seasons-list absolute l-[6px] top-[39px] hidden group-hover:block rounded-md rounded-tl-none bg-orange-500 shadow z-10 translate-x-0"
    >
      <!-- `translate-x-0`: Hoisting the stacking context + z-index above
        e.g. video previews and other transformed elements -->
      <li v-for="(item, index) in items" :key="item.key">
        <router-link
          :to="item.to"
          class="block py-3 px-4 text-white hover:bg-orange-600 whitespace-nowrap"
          :class="[
            {
              'rounded-tr-md': index === 0,
              'rounded-b-md': index === items.length - 1,
            },
          ]"
          activeClass="bg-blush-500 hover:bg-blush-600"
          >{{ item.title }}</router-link
        >
      </li>
    </ul>
  </li>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "MenuSection",
  components: {
    RouterLink,
  },
  props: {
    to: {
      type: Object,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
    },
  },
  methods: {
    onTouchStart(e) {
      if (e.target.classList.contains("has-nested-list")) {
        e.preventDefault();

        const nestedList = e.currentTarget.querySelector("ul");
        nestedList.classList.remove("hidden");

        document.addEventListener(
          "click",
          () => {
            nestedList.classList.add("hidden");
          },
          { once: true, passive: true },
        );
      }
    },
  },
};
</script>
